<template>
    <div class="indicator-widget">
        <div class="content-1" style='height: 80px;'>
            <div v-bind:class="'widget-circle circle-'+color"><div v-bind:class="'circle-'+color+'-img'"></div></div>
            <div class='widget-right'>
                <p class="number">{{valall}} - {{val1y}} - {{val6m}}</p>
                <p class="text">{{legend}}</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'indicator-widget',
    props: {
        legend: {
            required: true
        },
        color: {
            type: String,
            required: true
        },
        valall: {
            type: Number,
            default: 0,
        },
        val1y: {
            type: Number,
            default: 0,
        },
        val6m: {
            type: Number,
            default: 0,
        },
    },
}

</script>

<style scoped>

.content-1 {
    background: #1E1E1E;
    border-radius: 0;
    border: 1px solid #E2E2E2;
    border: none;
    color: #5b5b5b;
    margin-bottom: 20px;
    min-height: 30px;
    position: relative;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.widget-circle {
    border-radius: 50%;
    display: inline-block;
    height: 48px;
    margin-top: 0;
    padding: 13px;
    width: 48px;
    margin: 15px;
    float: left;
}

.circle-red {
    background-color: #c9625f !important;
}

.circle-red-img {
    background-image: url("../../../../assets/image/x.png");
    background-repeat: no-repeat;
    background-size: 22px auto;
    height: 30px;
    width: 30px;
}

.circle-green {
    background-color: #18a689 !important;
}

.circle-green-img {
    background-image: url("../../../../assets/image/check.png");
    background-repeat: no-repeat;
    background-size: 22px auto;
    height: 30px;
    width: 30px;
}

.circle-blue {
    background-color: #4584d1 !important;
}

.circle-blue-img {
    background-image: url("../../../../assets/image/clock.png");
    background-repeat: no-repeat;
    background-size: 22px auto;
    height: 30px;
    width: 30px;
}

.widget-right .number {
    font-family: "Lato","Open Sans",Arial;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 2px;
    color: #ffffff;
}

.widget-right .text {
    /* color: #a3a3a3; */
    color: #ffffff;
    font-size: 12px;
    text-align: left;
    text-transform: uppercase;
}

.widget-right {
    float: left;
    padding: 15px 0px 15px 10px;
}

@media screen and (max-width: 420px) {
   .widget-right {
        float: none;
    }
    .widget-right .number{
        font-size: 10px;
    }
    .widget-right .text{
        font-size: 10px;
    }

}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/Indicator-Widget.vue